import { useRef, useState, useEffect } from 'react';
import { useAnimatedText } from 'src/hooks/use-animate-text';

export const CohortTitle = ({ title }: { title: string }) => {
  const measureRef = useRef<HTMLSpanElement>(null);
  const [fullWidth, setFullWidth] = useState(0);

  useEffect(() => {
    if (measureRef.current) {
      setFullWidth(measureRef.current.offsetWidth);
    }
  }, [title]);

  const animatedText = useAnimatedText({ text: title, duration: 1.5 });

  return (
    <>
      <span ref={measureRef} className="absolute invisible whitespace-nowrap">
        {title}
      </span>

      <div style={{ width: fullWidth }}>
        <h1 className="text-lg text-dark-default-content whitespace-nowrap">{animatedText}</h1>
      </div>
    </>
  );
};
